import { ChangeDetectionStrategy, Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { B2BUnit, GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core';
import { CurrentItemService, CurrentUnitService, ItemService, MessageService, UnitItemService } from '@spartacus/organization/administration/components';
import { LoadStatus, OrgUnitService } from '@spartacus/organization/administration/core';
import { Observable } from 'rxjs';
import { first, map, switchMap, take } from 'rxjs/operators';
import { UigUnitFormService } from '../../services/uig-unit-form.service';

@Component({
    selector: 'app-uig-unit-form',
    templateUrl: './uig-unit-form.component.html',
    styleUrls: ['./uig-unit-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'content-wrapper' },
    providers: [
        {
            provide: ItemService,
            useExisting: UnitItemService,
        },
        {
            provide: CurrentItemService,
            useExisting: CurrentUnitService,
        },
    ],
    standalone: false
})
export class UigUnitFormComponent implements OnDestroy {
  @Input() i18nRoot = 'orgUnit';
  form$: Observable<UntypedFormGroup> = this.itemService.current$.pipe(
    map((item) => this.formService.getForm(item))
  );

  constructor(
    protected itemService: ItemService<B2BUnit>,
    protected unitService: OrgUnitService,
    protected formService: UigUnitFormService,
    private translationService: TranslationService,
    private globalMessageService: GlobalMessageService,
  ) {
    this.itemService.setEditMode(true);
  }

  save(form: UntypedFormGroup): void {
    this.itemService.key$
      .pipe(
        first(),
        switchMap((key) =>
          this.itemService.save(form, key).pipe(
            take(1),
            map((data) => ({
              item: data.item,
              status: data.status,
              action: key ? 'update' : 'create',
            }))
          )
        )
      )
      .subscribe(({ item, action, status }) => {
        if (status === LoadStatus.SUCCESS) {
          this.itemService.launchDetails(item);
          this.notify(item, action);
        }
        form.enable();
      });
  }

  protected notify(item: B2BUnit, action: string) {
    this.translationService
      .translate('units.editSuccess', { unitName: item.name })
      .subscribe((message) => {
        this.globalMessageService.add(
          message,
          GlobalMessageType.MSG_TYPE_CONFIRMATION
        );
      });
  }

  ngOnDestroy(): void {
    this.itemService.setEditMode(false);
  }
}
